import {
  GET_MY_WM_PREFERENCE_VERIFICATION_FAILED,
  GET_MY_WM_PREFERENCE_VERIFICATION_PENDING,
  GET_MY_WM_PREFERENCE_VERIFICATION_FULFILLED,
  GET_MY_WM_PREFERENCE_VERIFICATION_STORE_JWT,
  GET_CUSTOMER_VERIFICATION_PENDING,
  RESET_DASHBOARD_FROM_GETTING_STARTED,
  RESET_MYSERVICES_DASHBOARD,
  RESET_CUSTOMER_CONTACTS,
} from "constants-lib/actionTypes"

const initialState = {
  fetchCode: 0,
  fetchState: ``,
  errorMessage: ``,
  jwtPreference: ``,
  verificationToken: ``,
  data: {
    customerVerified: ``,
  },
  customerId: ``,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_MY_WM_PREFERENCE_VERIFICATION_FAILED:
      return {
        data: {
          customerVerified: action.payload.customerVerified,
        },
        errorMessage: action.payload.errorMessage,
        fetchCode: action.payload.fetchCode,
        fetchState: `failed`,
      }

    case GET_MY_WM_PREFERENCE_VERIFICATION_PENDING:
      return {
        ...initialState,
        data: {},
        fetchState: `pending`,
        customerId: action.payload,
      }

    case GET_MY_WM_PREFERENCE_VERIFICATION_FULFILLED:
      return {
        ...state,
        fetchState: `fulfilled`,
        ...action.payload,
      }

    case GET_MY_WM_PREFERENCE_VERIFICATION_STORE_JWT:
      return {
        ...state,
        verificationToken: action.payload.jwtPreference,
      }

    // case GET_CUSTOMER_ACCOUNT_PENDING:
    case GET_CUSTOMER_VERIFICATION_PENDING:
    case RESET_DASHBOARD_FROM_GETTING_STARTED:
    case RESET_MYSERVICES_DASHBOARD:
    case RESET_CUSTOMER_CONTACTS:
      return {
        ...initialState,
        data: {},
      }

    default:
      return state
  }
}
